import { jsx as _jsx } from "react/jsx-runtime";
import { buildWebsiteUrl, WebsiteURL } from "healthex-common/websiteurls";
import { Trans, useTranslation } from "react-i18next";
import { i18nGetCurrentLanguage } from "../Infra/i18next";
import { FooterTextLink } from "./PatientConsentManagerShared.styles";
export const PatientConsentTermsAndPrivacyFooterText = (props) => {
    const { t } = useTranslation(["patients"]);
    const { webAddress } = props;
    return (_jsx(Trans, { t: t, i18nKey: "By continuing, you agree to HealthEx\u2019s\u00A0<terms>Terms</terms> and <privacy>Privacy Policy</privacy>.", components: {
            terms: (_jsx(FooterTextLink, { href: buildWebsiteUrl(WebsiteURL.TERMS, webAddress, i18nGetCurrentLanguage()), target: "_blank", rel: "noopener noreferrer" })),
            privacy: (_jsx(FooterTextLink, { href: buildWebsiteUrl(WebsiteURL.PRIVACY, webAddress, i18nGetCurrentLanguage()), target: "_blank", rel: "noopener noreferrer" })),
        } }));
};
